import Modal from '@Components/Shared/Modals/Modal';
import translator from '@Components/Utilities/Translator';

const ConsignmentPackageInfoModal = (props) => {

    const onClose = () => {
        props.toggleModal();
    };

    return (
        <Modal containerClassName='consignment-package-info-modal ts-modal-container' onEscapeKeyClose={onClose}>
            <Modal.Header onClose={onClose}>
                <Modal.Title>
                    {props.EventTitle}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {props.Description &&
                    <div className='description'>
                        <span>{props.Description}</span>
                    </div>}
                <div className='contact-info-container'>
                    <span className='contact-info-header'><strong>{translator.translate('sandhills.tradepubwebsite.mvc.contactinfo')}</strong></span>

                    <div className='contact-information'>
                        {props.Name &&
                            <div className='seller-information'>
                                <span><strong>{translator.translate('sandhills.sellerinformation')}</strong></span>
                                <div>{props.Name}</div>
                                {props.DealerAddress && 
                                    <div>{props.DealerAddress}</div>}
                                {props.DealerCityStatePostal &&
                                    <div>{props.DealerCityStatePostal}</div>}
                                {props.UnformattedDealerPhoneNumber &&
                                    <div>
                                        <a id='dealer-phone-number' href={'tel:' + props.UnformattedDealerPhoneNumber}>
                                            {props.FormattedDealerPhoneNumber ?? props.UnformattedDealerPhoneNumber}
                                        </a>
                                    </div>}
                            </div>}

                        {props.DisplayConsignorInformation &&
                            <div className='consignor-information'>
                                <span><strong>{translator.translate('sandhills.crm.dscrm.consignorinfo')}</strong></span>
                                {props.ConsignorCompanyName &&
                                    <div>{props.ConsignorCompanyName}</div>}
                                {props.ConsignorName &&
                                    <div>{props.ConsignorName}</div>}
                                {props.ConsignorEmail &&
                                    <div>{props.ConsignorEmail}</div>}
                                {props.ConsignorPhoneNumber &&
                                    <div>
                                        <a id='consignor-phone-number' href={'tel:' + props.ConsignorPhoneNumber}>
                                            {props.ConsignorPhoneNumberFormatted ?? props.ConsignorPhoneNumber}
                                        </a>
                                    </div>}
                                {props.ConsignorPreferredMethodOfContact &&
                                    <div>
                                        {translator.translate('sandhills.preferredcontactmethod')}:&nbsp;
                                        {props.ConsignorPreferredMethodOfContact}
                                    </div>}
                                {props.ConsignorPreferredContactTimeOfDay &&
                                    <div>
                                        {translator.translate('sandhills.preferredcontacttime')}:&nbsp;
                                        {props.ConsignorPreferredContactTimeOfDay}
                                    </div>}
                            </div>}
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ConsignmentPackageInfoModal;
